import { Button, Grid, Layout, Paper, Table, Loader } from "../../components";
import { useAxios, useToggle } from '../../hooks'
import { Fragment, useState } from "react";
import { formatNumber } from "../../utils";
import { AddEditDepartmentModal } from "./components/AddEditDepartmentModal";
import EditIcon from '@mui/icons-material/Edit';
import { GridActionsCellItem } from "@mui/x-data-grid-pro";

export function Departments () {
    const [departmentIdToEdit, setDepartmentIdToEdit] = useState<string>('')
    const [isAddEditModalVisible, isAddEditModalVisibleControls] = useToggle(false)

    const [departments, refetchDepartments] = useAxios(`/department`)
    
    return (
        <Layout>
            <Grid container justifyContent="center" padding={3} spacing={2}>
                {departments.loading || departments.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) : ( 
                    <Fragment>
                        {
                            isAddEditModalVisible && (
                                <AddEditDepartmentModal 
                                    id={departmentIdToEdit}
                                    onCancel={() => {
                                        setDepartmentIdToEdit('')
                                        isAddEditModalVisibleControls.setFalse()
                                    }}
                                    onSuccess={() => {
                                        setDepartmentIdToEdit('')
                                        isAddEditModalVisibleControls.setFalse()
                                        refetchDepartments()
                                    }}
                                />
                            )
                        }
                        <Grid item xs={10} textAlign={"right"}>
                            <Button onClick={isAddEditModalVisibleControls.setTrue}>
                                Adicionar
                            </Button>
                        </Grid>
                    <Grid item xs={12} sm={10}>
                        <Paper elevation={1}>
                        <Table 
                            rowHeight={65}
                            columns={[
                                { field: 'name', headerName: 'Nome', flex: 1 },
                                { field: 'order_bonus', headerName: 'Comissão do Emissor', flex: 1, valueGetter: ({row}) => {
                                    return `${formatNumber(row.department_bonus[0].bonus_order_percent)}%`
                                }},
                                { field: 'manager_bonus', headerName: 'Comissão do Emissor', flex: 1, valueGetter: ({row}) => {
                                    return `${formatNumber(row.department_bonus[0].manager_bonus_order_percent)}%`
                                }},
                                { field: 'user_department', headerName: 'Emissores', flex: 2, valueGetter: (row) => {
                                    return row.value.map((d: {user: { name: string}}) => d.user.name).join(', ')
                                }},
                                { field: 'manager_department', headerName: 'Gerentes', flex: 2,  valueGetter: (row) => {
                                    return row.value.map((d: {user: { name: string}}) => d.user.name).join(', ')
                                }},
                                {
                                    field: 'actions', type: 'actions', headerName: '', align: 'right', 
                                    getActions: ({ id }) => {
                                        return [
                                          <GridActionsCellItem
                                              icon={<EditIcon />}
                                              label="Editar"
                                              onClick={() => {
                                                setDepartmentIdToEdit(id as unknown as string)
                                                isAddEditModalVisibleControls.setTrue()
                                              }}
                                              color="inherit"
                                          />,
                                        ];
                                      },
                                }
                            ]}
                            rows={(departments?.data || [])}
                        />
                        </Paper>
                    </Grid>
                
                </Fragment>)}
            </Grid>
        </Layout>
    )
}